export default "__VITE_ASSET__C6WxYze0__"